import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Form, TreeSelect, Space, Row, Col } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { formItemLayout, tailLayout } from '../../js/globalParam'
import _ from 'lodash'

export default function RoleEdit() {

    const { id }: { id: string | undefined } = useParams()
    const [form] = useForm()

    const [pageTitle, setPageTitle] = useState<string>('')

    const [menuData, setMenuData] = useState<any[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/global/menu_tree_list').then((res: any) => {
            res && setMenuData(filterTreeData(res))
        })

        if (id) {
            baseAxiosNoInfo('/manpower_center/role/detail', { params: { id } }).then((res: any) => {
                if (res) {
                    form.setFieldsValue({
                        role_name: res.role_name,
                        role_menu_list: res.menu_id_list
                    })
                }
            })

            setPageTitle('编辑角色')

        } else {
            setPageTitle('新增角色')
        }
    }, [])

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    const filterTreeData = (res: any) => {
        return res.map((el: any) => ({
            title: el.name,
            value: el.id,
            key: el.id,
            children: el.children && recursionChildren(el.children)
        }))
    }

    const onFinish = (values: any) => {
        let url = id ? '/manpower_center/role/update' : '/manpower_center/role/add'

        axiosHandleEvent.post(url, {
            id,
            role_name: values.role_name,
            menu_id_list: values.role_menu_list.map((el: { value: string }) => el.value)
        }).then(res => {

        })
    }

    return (<div className="common-level2-edit">
        {/* 人力中心 -> 员工及角色 -> 角色管理 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish}>
                <Form.Item label="角色名称" name="role_name" rules={[{ required: true, message: '输入角色名称' }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="菜单配置" name="role_menu_list" rules={[{ required: true, message: '选择菜单' }]} >
                    <TreeSelect treeCheckable={true} treeCheckStrictly={true} virtual={true} treeData={menuData} placeholder="" />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>)
}